import React, { FC } from "react";
import type { ClearingInstitutionsRegulatorsProps } from "@/types";
import { Image } from "../image";
import { TextCols } from "../text-cols";

export const ClearingInstitutionsRegulators: FC<
  ClearingInstitutionsRegulatorsProps
> = ({ content, cover }) => {
  return (
    <section className="clearingInstitutionsRegulators">
      <div className="clearingInstitutionsRegulators--inner">
        <div className="wrapper">
          <TextCols content={content} maxTitleWidth={766} />
        </div>
        <div className="wrapper wrapper_lg">
          {cover.file?.url && (
            <Image
              className="clearingInstitutionsRegulators--cover"
              src={cover as any}
              alt={cover.title}
              animateInView
            />
          )}
        </div>
      </div>
    </section>
  );
};
